export default __webpack_public_path__ + "static/media/CROP DAMAGE.a9f456e3.jpg";